import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { mealPlanService } from './meal-plan.service'
import { showToast } from '@/shared/utils/toast'
import type { WeeklyMealPlan, SuggestionActionPayload } from './types'

export function useDismissSuggestion(weekStartDate: string) {
  const queryClient = useQueryClient()
  const { t } = useTranslation('meal-plan')

  return useMutation({
    mutationFn: (payload: SuggestionActionPayload) => mealPlanService.dismissSuggestion(payload),
    onMutate: async (payload) => {
      const queryKey = ['meal-plan', weekStartDate]
      await queryClient.cancelQueries({ queryKey })
      const prev = queryClient.getQueryData<WeeklyMealPlan>(queryKey)

      queryClient.setQueryData<WeeklyMealPlan>(queryKey, (old) => {
        if (!old) return old
        return {
          ...old,
          slots: old.slots.map((slot) =>
            slot.dayOfWeek === payload.dayOfWeek
              ? {
                  ...slot,
                  recipeId: null,
                  recipeName: null,
                  servingSize: null,
                  servingMultiplier: 1.0,
                  isSuggestion: false,
                  suggestedByMemberName: null,
                }
              : slot,
          ),
        }
      })

      return { prev }
    },
    onError: (_err, _payload, ctx) => {
      queryClient.setQueryData(['meal-plan', weekStartDate], ctx?.prev)
      showToast(t('error.dismissFailed'))
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['meal-plan', weekStartDate] })
    },
  })
}
